import { useState, useEffect } from 'react';
import { Box, Card, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography, Chip, useTheme } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { ButtonBasic, CardItemServiciosModal } from '../../components';
import ApiSoftland from '../../services/apis.softland.service';
import KmzService from '../../services/kmz.service';
import TratoService from '../../services/tratos.service';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

function ModalSelectPlanes({
    show,
    hideModal,
    onGuardar,
    preServicio
}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const handleClose = () => hideModal();
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [arrPlanes, setArrPlanes] = useState([]);
    const [planSelect, setPlanSelect] = useState(null);
    const [planActual, setPlanActual] = useState(null);
    const [coberturaActual, setCoberturaActual] = useState({
        rf: 0,
        fo: 0
    });
    const [tecnologiaPrefa, setTecnologiaPrefa] = useState(preServicio?.tipoTecnologia_t === 'RE' ? 'RF' : 'FO');
    const obtenerPlan = async() => {
        setIsLoading(true);
        const tipo = preServicio?.tipoConSoft_t === 'HOGAR' ? 'HO' : 'PY';
        await ApiSoftland.getProductos(`${tipo}${tecnologiaPrefa}`,{localidadFO: preServicio?.lugarId_t}).then((resp)=>{
            setIsLoading(false);
            setArrPlanes(resp)
        })
    }
    useEffect(() => {
        obtenerPlan()
        setPlanSelect(null);
    }, [tecnologiaPrefa])

    const obtenerPlanActual = () => {
        if(preServicio?.tratoserv && preServicio?.tratoserv.length > 0){
            const planAct = preServicio?.tratoserv.find((p)=>p.tipoServicio_ds?.trim() !== 'SAI')
            setPlanActual(planAct)
        }
    }
    const obtenerCoberturaActual = async () => {
        if(preServicio?.coordenadas_t){
            setIsLoading(true);
            await KmzService.coberturaAllCambioPlan({
                latitud: preServicio?.latitud_t,
                longitud: preServicio?.longitud_t
            }).then((resp) => {
                if(resp?.coordenadas){
                    setCoberturaActual({
                        rf: resp?.coberturaRF?.coberturaMaximaMB || 0,
                        fo: resp?.coberturaFO?.coberturaMaximaMB || 0
                    })
                }
            }).finally(() => setIsLoading(false));
        }
    }
    const onSubmit = async() => {
        setIsLoading(true);
        const form = {
            tecnologiaPrefa,
            planSelect,
            tratoId: preServicio?.id_t,
        }
        await TratoService.changePlanPreServicio(form).then(() => {
            if(onGuardar){
                onGuardar()
            }
            setShowConfirmDialog(false);
            handleClose();
        }).finally(() => { setIsLoading(false); });
    }
    
    const handleConfirmarClick = () => {
        setShowConfirmDialog(true);
    }
    
    const getPlanSeleccionadoInfo = () => {
        return arrPlanes.find(p => p.cod_producto === planSelect?.cod_producto);
    }
    useEffect(() => {
        obtenerPlan()
        obtenerPlanActual()
        obtenerCoberturaActual()
    }, [])
    
    const planSeleccionado = getPlanSeleccionadoInfo();
    
    return (
        <>
            <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth className='side'>
                <Box sx={{background: isDarkMode ? '#2d3a52' : '#fff'}} className='side'>
                    <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                        <Typography sx={{flex:1,textAlign: 'start', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                            Seleccionar Plan
                        </Typography>
                    </DialogTitleDefault>
                    <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                    <DialogContent className='side'>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Card sx={{p: 2, background: isDarkMode ? '#2d3a52 !important' : '#fff !important', border: isDarkMode ? '1px solid #3d4a62' : 'none', boxShadow: 3, borderRadius: 3, height: '100%', display:'flex', justifyContent:'center', flexDirection: 'column', alignItems: 'center'}}>
                                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold', fontSize: 16, mb: 1}}>
                                            Tecnologías disponibles
                                        </Typography>
                                        <FormControl>
                                            <RadioGroup
                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                name="controlled-radio-buttons-group"
                                                value={tecnologiaPrefa}
                                                onChange={(e) => setTecnologiaPrefa(e.target.value)}
                                                row
                                            >
                                                <FormControlLabel
                                                    value="RF"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: '#6b788e',
                                                                '&.Mui-checked': {
                                                                    color: '#0364ff',
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={<Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}}>{`RF (${coberturaActual?.rf}Mb)`}</Typography>}
                                                    sx={{color: isDarkMode ? '#e0e0e0' : '#000', mr: 2}}
                                                    disabled={coberturaActual?.rf === 0}
                                                />
                                                <FormControlLabel
                                                    value="FO"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: '#6b788e',
                                                                '&.Mui-checked': {
                                                                    color: '#0364ff',
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={<Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}}>{`FO (${coberturaActual?.fo}Mb)`}</Typography>}
                                                    sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}
                                                    disabled={coberturaActual?.fo === 0}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Card sx={{
                                        p: 2, 
                                        background: planActual?.nombreServicio_ds ? 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' : (isDarkMode ? '#2d3a52' : '#f5f5f5'), 
                                        border: isDarkMode && !planActual?.nombreServicio_ds ? '1px solid #3d4a62' : 'none',
                                        boxShadow: 3, 
                                        borderRadius: 3, 
                                        height: '100%', 
                                        display:'flex', 
                                        justifyContent:'center', 
                                        flexDirection: 'column', 
                                        alignItems: 'center',
                                        minHeight: '120px'
                                    }}>
                                        <Typography sx={{
                                            color: planActual?.nombreServicio_ds ? '#fff' : (isDarkMode ? '#e0e0e0' : '#000'), 
                                            fontWeight: 'bold', 
                                            fontSize: 18, 
                                            mb: 1
                                        }}>
                                            Plan Actual
                                        </Typography>
                                        {planActual?.nombreServicio_ds ? (
                                            <Box sx={{textAlign: 'center'}}>
                                                <Typography sx={{color: '#fff', fontSize: 16, fontWeight: '500', mb: 0.5}}>
                                                    {planActual.nombreServicio_ds}
                                                </Typography>
                                                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1}}>
                                                    <Box sx={{
                                                        background: 'rgba(255, 255, 255, 0.2)',
                                                        borderRadius: 2,
                                                        px: 1.5,
                                                        py: 0.5,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 0.5
                                                    }}>
                                                        <Typography sx={{color: '#fff', fontSize: 24, fontWeight: 'bold'}}>
                                                            {planActual.anchoBajadaServicio_ds ? parseFloat(planActual.anchoBajadaServicio_ds).toFixed(0) : 'N/A'}
                                                        </Typography>
                                                        <Typography sx={{color: '#fff', fontSize: 14}}>
                                                            {planActual.tipoAnchoBajada_ds || 'MB'}
                                                        </Typography>
                                                    </Box>
                                                    <Typography sx={{color: '#fff', fontSize: 14}}>•</Typography>
                                                    <Typography sx={{color: '#fff', fontSize: 20, fontWeight: 'bold'}}>
                                                        {`${planActual.moneda_ds === 'USD' ? '$' : planActual.moneda_ds} ${parseFloat(planActual.importeServicio_ds).toFixed(2)}`}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        ) : (
                                            <Box sx={{textAlign: 'center'}}>
                                                <Typography sx={{color: '#6b788e', fontSize: 15, fontStyle: 'italic'}}>
                                                    Sin plan asignado
                                                </Typography>
                                            </Box>
                                        )}
                                    </Card>
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider sx={{my: 1, borderColor: isDarkMode ? '#3d4a62' : 'rgba(0,0,0,0.12)'}} />
                                    <Box sx={{
                                        background: isDarkMode ? 'rgba(255, 193, 7, 0.15)' : '#fff3cd', 
                                        border: isDarkMode ? '1px solid rgba(255, 193, 7, 0.3)' : '1px solid #ffc107', 
                                        borderRadius: 2, 
                                        p: 1.5, 
                                        mb: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1
                                    }}>
                                        <Typography sx={{fontSize: 20}}>⚠️</Typography>
                                        <Typography sx={{color: isDarkMode ? '#fbbf24' : '#856404', fontSize: 14, lineHeight: 1.5}}>
                                            <strong>Importante:</strong> Si el pre-servicio tiene bonificaciones aplicadas, estas se ajustarán automáticamente al precio del nuevo plan seleccionado.
                                        </Typography>
                                    </Box>
                                    <Typography sx={{textDecoration: 'underline', color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold', fontSize: 16, mb: 1, textAlign: 'center'}}>
                                        Selecciona un nuevo plan
                                    </Typography>
                                </Grid>
                                {arrPlanes?.length > 0 ? (
                                    arrPlanes.map((serv)=>(
                                        <Grid item xs={12} md={6} key={serv.cod_producto}>
                                            <CardItemServiciosModal
                                                item={serv}
                                                servicioSelect={planSelect}
                                                setServicioSelect={setPlanSelect}
                                                coberturaMaxima={tecnologiaPrefa === 'RF' ? coberturaActual?.rf : coberturaActual?.fo}
                                                disabledPrefa
                                            />
                                        </Grid>
                                    ))
                                ) : (
                                    <Grid item xs={12}>
                                        <Box sx={{
                                            display: 'flex', 
                                            justifyContent: 'center', 
                                            alignItems: 'center', 
                                            minHeight: '200px',
                                            flexDirection: 'column'
                                        }}>
                                            {isLoading ? (
                                                <Typography sx={{color: isDarkMode ? '#b0bec5' : '#6b788e', fontSize: 16}}>
                                                    Cargando planes...
                                                </Typography>
                                            ) : (
                                                <Typography sx={{color: isDarkMode ? '#b0bec5' : '#6b788e', fontSize: 16}}>
                                                    No hay planes disponibles para esta tecnología
                                                </Typography>
                                            )}
                                        </Box>
                                    </Grid>
                                )}
                            </Grid>
                    </DialogContent>
                    <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                        <ButtonBasic
                            textButton='Cancelar'
                            variant='wk'
                            color='cancel'
                            onClick={()=>handleClose()}
                            sx={{mb:2}}
                        />
                        <ButtonBasic
                            textButton='Confirmar'
                            variant='wk'
                            color='nextStep'
                            onClick={()=>handleConfirmarClick()}
                            sx={{mb:2}}
                            isLoading={isLoading}
                            isDisabled={!planSelect}
                        />
                    </DialogActions>
                </Box>
            </Dialog>
            {/* Dialog de Confirmación */}
            <Dialog
                open={showConfirmDialog}
                onClose={() => setShowConfirmDialog(false)}
                maxWidth='xs'
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        borderRadius: 3,
                        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                    }
                }}
            >
                <DialogTitle sx={{
                    textAlign: 'center',
                    pb: 1,
                    pt: 3,
                    background: 'linear-gradient(135deg, #0364ff 0%, #0247b5 100%)',
                    color: '#fff'
                }}>
                    <Box display='flex' alignItems='center' justifyContent='center' gap={1}>
                        <WarningAmberIcon sx={{ fontSize: 28, color: '#fff' }} />
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#fff' }}>
                            Confirmar Cambio de Plan
                        </Typography>
                    </Box>
                </DialogTitle>
                <Divider />

                <DialogContent sx={{ pt: 3, pb: 2, background: isDarkMode ? '#2d3a52 !important' : '#fff !important' }}>
                    {/* Plan Actual */}
                    <Box mb={2}>
                        <Typography sx={{ color: isDarkMode ? '#b0bec5' : '#718096', fontSize: 12, fontWeight: 600, mb: 1, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Plan Actual
                        </Typography>
                        <Card sx={{
                            p: 2,
                            background: isDarkMode ? 'linear-gradient(135deg, #1F2A40 0%, #1a2332 100%)' : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                            border: isDarkMode ? '2px solid #3d4a62' : '2px solid #dee2e6',
                            borderRadius: 2,
                            boxShadow: 'none'
                        }}>
                            {planActual?.nombreServicio_ds ? (
                                <>
                                    <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#2d3748', fontWeight: 600, fontSize: 15, mb: 1 }}>
                                        {planActual.nombreServicio_ds}
                                    </Typography>
                                    <Box display='flex' gap={1} flexWrap='wrap'>
                                        <Chip
                                            label={`${parseFloat(planActual.anchoBajadaServicio_ds).toFixed(0)} ${planActual.tipoAnchoBajada_ds || 'MB'}`}
                                            size="small"
                                            sx={{
                                                backgroundColor: '#5c7cfa',
                                                color: '#fff',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        />
                                        <Chip
                                            label={`${planActual.moneda_ds === 'USD' ? '$' : planActual.moneda_ds} ${parseFloat(planActual.importeServicio_ds).toFixed(2)}`}
                                            size="small"
                                            sx={{
                                                backgroundColor: '#748ffc',
                                                color: '#fff',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        />
                                    </Box>
                                </>
                            ) : (
                                <Typography sx={{ color: isDarkMode ? '#b0bec5' : '#718096', fontSize: 14, fontStyle: 'italic' }}>
                                    Sin plan asignado
                                </Typography>
                            )}
                        </Card>
                    </Box>
                    {/* Flecha indicadora */}
                    <Box display='flex' justifyContent='center' my={1}>
                        <ArrowDownwardIcon sx={{ fontSize: 32, color: '#0364ff' }} />
                    </Box>
                    {/* Nuevo Plan */}
                    <Box mb={2}>
                        <Typography sx={{ color: isDarkMode ? '#b0bec5' : '#718096', fontSize: 12, fontWeight: 600, mb: 1, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Nuevo Plan
                        </Typography>
                        <Card sx={{
                            p: 2,
                            background: isDarkMode ? 'linear-gradient(135deg, rgba(3, 100, 255, 0.2) 0%, rgba(3, 100, 255, 0.1) 100%)' : 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                            border: isDarkMode ? '2px solid #90caf9' : '2px solid #0364ff',
                            borderRadius: 2,
                            boxShadow: 'none'
                        }}>
                            {planSeleccionado && (
                                <>
                                    <Typography sx={{ color: isDarkMode ? '#90caf9' : '#01579b', fontWeight: 700, fontSize: 15, mb: 1 }}>
                                        {planSeleccionado.nombre}
                                    </Typography>
                                    <Box display='flex' gap={1} flexWrap='wrap' mb={1}>
                                        <Chip 
                                            label={`${parseFloat(planSeleccionado.bajada).toFixed(0)} ${planSeleccionado.unidad_bajada || 'MB'}`}
                                            size="small"
                                            sx={{ 
                                                backgroundColor: '#0364ff',
                                                color: '#fff',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        />
                                        <Chip 
                                            label={`USD ${parseFloat(planSeleccionado.precio).toFixed(2)}`}
                                            size="small"
                                            sx={{ 
                                                backgroundColor: '#0247b5',
                                                color: '#fff',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        />
                                        <Chip 
                                            label={tecnologiaPrefa === 'RF' ? 'Radio Frecuencia' : 'Fibra Óptica'}
                                            size="small"
                                            icon={<CheckCircleIcon sx={{ fontSize: 16, color: '#fff !important' }} />}
                                            sx={{ 
                                                backgroundColor: '#01579b',
                                                color: '#fff',
                                                fontWeight: 600,
                                                fontSize: 11
                                            }}
                                        />
                                    </Box>
                                </>
                            )}
                        </Card>
                    </Box>
                    {/* Advertencia de bonificaciones */}
                    {preServicio?.bonificacion_t && parseFloat(preServicio.bonificacion_t) > 0 && (
                        <Box sx={{
                            background: isDarkMode ? 'rgba(255, 193, 7, 0.15)' : '#fff3cd',
                            border: isDarkMode ? '1px solid rgba(255, 193, 7, 0.3)' : '1px solid #ffc107',
                            borderRadius: 2,
                            p: 1.5,
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 1
                        }}>
                            <WarningAmberIcon sx={{ color: isDarkMode ? '#fbbf24' : '#856404', fontSize: 20, mt: 0.2 }} />
                            <Typography sx={{ color: isDarkMode ? '#fbbf24' : '#856404', fontSize: 12, lineHeight: 1.5 }}>
                                <strong>Nota:</strong> Las bonificaciones se ajustarán automáticamente al precio del nuevo plan.
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
                <Divider sx={{ borderColor: isDarkMode ? '#3d4a62' : 'rgba(0,0,0,0.12)' }} />
                <DialogActions sx={{ p: 2, gap: 1, justifyContent: 'center', background: isDarkMode ? '#2d3a52 !important' : '#fff !important' }}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={() => setShowConfirmDialog(false)}
                        isDisabled={isLoading}
                    />
                    <ButtonBasic
                        textButton='Confirmar Cambio'
                        variant='wk'
                        color='nextStep'
                        onClick={onSubmit}
                        isLoading={isLoading}
                    />
                </DialogActions>
            </Dialog>
        </>
    );
}
export default ModalSelectPlanes;